<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M16.5 9L12 4 7.5 9M12 16.5v-12M20.5 11v8.5a1 1 0 01-1 1h-15a1 1 0 01-1-1V11"/>
</svg>
